import { usePayee } from "@/payee.composable";
import { nextTick, Ref } from "vue";

export async function setupStax(staxJsRef: Ref<any>) {
  // stax wasn't really built with vue in mind, we have to wait for the page to finish rendering
  await nextTick();
  await waitFor(300);

  try {
    staxJsRef.value = populateStax();
    await staxJsRef.value.showCardForm();
  } catch (error) {
    console.log(error);
    await waitFor(200);
    staxJsRef.value = populateStax();
    await staxJsRef.value.showCardForm();
  }
}

function populateStax() {
  const { payee } = usePayee();

  // EPAY-416: Updated StaxJs constructor to match new StaxJs requirements as defined in https://docs.staxpayments.com/docs/tokenizing-a-credit-card
  // eslint-disable-next-line no-undef,@typescript-eslint/ban-ts-comment
  // @ts-ignore
  return new StaxJs(payee.value?.webPaymentToken, {
    number: {
      id: "card-number", // the html id of the div you want to contain the credit card number field
      placeholder: "0000 0000 0000 0000", // the placeholder the field should contain
      style: "height: 40px; width: 100%; font-size: 16px; padding-left: 16px", // the style to apply to the field
      type: "text", // the input type (optional)
      format: "prettyFormat", // the formatting of the CC number (prettyFormat || plainFormat || maskedFormat)
    },
    cvv: {
      id: "cvv-number", // the html id of the div you want to contain the cvv field
      placeholder: "CVV", // the placeholder the field should contain
      style: "height: 40px; width: 100%; font-size: 16px; padding-left: 16px",
      type: "text", // the input type (optional)
    },
  });
}

function waitFor(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}
